<div>
  <!-- main app container -->
  <div class="card m-3">
    <h5 class="card-header">Payment Related Issue</h5>
    <div class="card-body">
      <form [formGroup]="bdnuForm" (ngSubmit)="onSubmit()">
        <div class="form-row">
          <div class="form-group col-3">
            <label>State</label>

            <select formControlName="state" class="form-control"
              [ngClass]="{ 'is-invalid': submitted && f.state.errors }" (change)="onChangeState($event)">
              <option [selected]="true" value="" [disabled]="true">Select State</option>
              <option *ngFor="let country of state" [value]="country.state_name">
                {{ country.state_name }}
              </option>
            </select>
            <div *ngIf="submitted && f.state.errors" class="invalid-feedback">
              <div *ngIf="f.state.errors.required">state is required</div>
            </div>
          </div>

          <div class="form-group col-3">
            <label>District</label>

            <select formControlName="district" class="form-control"
              [ngClass]="{ 'is-invalid': submitted && f.district.errors }">
              <option [selected]="true" value="" [disabled]="true">Select District</option>
              <option *ngFor="let country of district" [value]="country.district_name">
                {{ country.district_name }}
              </option>
            </select>
            <div *ngIf="submitted && f.district.errors" class="invalid-feedback">
              <div *ngIf="f.district.errors.required">District is required</div>
            </div>
          </div>

          <div class="form-group col-3">
            <label>ITI Code</label>
            <select formControlName="iticode" class="form-control"
              [ngClass]="{ 'is-invalid': submitted && f.iticode.errors }">
              <option [selected]="true" value="" [disabled]="true">Select ITI Code</option>
              <option *ngFor="let city of cities" [value]="city">
                {{ city }}
              </option>
            </select>
            <div *ngIf="submitted && f.iticode.errors" class="invalid-feedback">
              <div *ngIf="f.iticode.errors.required">
                ITI code is required
              </div>
            </div>
          </div>

          <div class="form-group col-3">
            <label>Trade</label>
            <select formControlName="trade" class="form-control"
              [ngClass]="{ 'is-invalid': submitted && f.trade.errors }">
              <option [selected]="true" value="" [disabled]="true">Select Trade</option>
              <option *ngFor="let trad of trades" [value]="trad">
                {{ trad }}
              </option>
            </select>
            <div *ngIf="submitted && f.trade.errors" class="invalid-feedback">
              <div *ngIf="f.trade.errors.required">
                ITI code is required
              </div>
            </div>
          </div>

          <div class="form-group col-4">
            <label>Name</label>
            <input type="text" formControlName="name" class="form-control"
              [ngClass]="{ 'is-invalid': submitted && f.name.errors }" maxlength="50" placeholder="Enter Your Name" />
            <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
              <div *ngIf="f.name.errors.required">Name is required</div>
            </div>
          </div>

          <div class="form-group col-4">
            <label>Email</label>
            <input type="text" formControlName="email" class="form-control"
              [ngClass]="{ 'is-invalid': submitted && f.email.errors }" maxlength="50"
              placeholder="Enter Your Email Address" />
            <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
              <div *ngIf="f.email.errors.required">Email is required</div>
              <div *ngIf="f.email.errors.email">
                Email must be a valid email address
              </div>
              <div *ngIf="f.email.errors.pattern">
                Email must be a valid email pattern address
              </div>
            </div>
          </div>

          <div class="form-group col-4">
            <label>Mobile Number</label>
            <input type="text" formControlName="mobileno" class="form-control"
              [ngClass]="{ 'is-invalid': submitted && f.mobileno.errors }" maxlength="10"
              placeholder="Enter Your Mobile Number" />
            <div *ngIf="submitted && f.mobileno.errors" class="invalid-feedback">
              <div *ngIf="f.mobileno.errors.required">
                Mobile no required
              </div>
            </div>
            <div *ngIf="submitted && f.mobileno.errors" class="invalid-feedback">
              <div *ngIf="f.mobileno.errors.pattern">
                Enter Only Number
              </div>
            </div>
            <!-- <div *ngIf="submitted && f.mobileno.errors" class="invalid-feedback">
                      <div *ngIf="f.mobileno.errors.max"> Mobile no must 10 digit</div>
                  </div> -->
          </div>

          <div class="form-group col-4">
            <label>CC Refernce Number</label>
            <input type="text" formControlName="ccrefno" class="form-control"
              [ngClass]="{ 'is-invalid': submitted && f.ccrefno.errors }" maxlength="12"
              placeholder="Enter CC Ref Number" />
            <div *ngIf="submitted && f.ccrefno.errors" class="invalid-feedback">
              <div *ngIf="f.ccrefno.errors.required">
                CC ref no required
              </div>
            </div>
            <div *ngIf="submitted && f.ccrefno.errors" class="invalid-feedback">
              <div *ngIf="f.ccrefno.errors.pattern">
                Enter Only Number
              </div>
            </div>
          </div>

          <div class="form-group col-4">
            <label>Order Id</label>
            <input type="text" formControlName="orderid" class="form-control" maxlength="20"
              placeholder="Enter Order ID" />

          </div>

          <div class="form-group col-4">
            <label>Payment Date</label>
            <!-- <input type="date" formControlName="date" pattern="\d{4}-\d{2}-\d{2}"  class="form-control" [ngClass]="{ 'is-invalid': submitted && f.date.errors }" /> -->
            <!-- <mat-form-field>
                    <input matInput placeholder="Choose a date">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field> -->

            <!-- <dp-date-picker theme="dp-material" class=" date_cus" [config]="datePickerConfig" required="true" formControlName="date" [ngClass]="{ 'is-invalid': submitted && f.date.errors }" [disabled]="true"> </dp-date-picker> -->

            <!-- <input name="someName" [disabled]="false" theme="dp-material" class="form-control" formControlName="date"  [dpDayPicker]="datePickerConfig" [ngClass]="{ 'is-invalid': submitted && f.date.errors }"/> -->

            <input theme="dp-material" class="form-control" formControlName="date" [dpDayPicker]="datePickerConfig"
              [ngClass]="{ 'is-invalid': submitted && f.date.errors }" placeholder="Enter Payment Date"
              maxlength="10" />

            <div *ngIf="submitted && f.date.errors" class="invalid-feedback">
              <div *ngIf="f.date.errors.required">
                Payment Date is required
              </div>
            </div>
          </div>

          <div class="col-md-2">
            <label style="display: block; text-align: left;">Type of Payment Done </label>
            <div style="text-align: left;">
              <input type="radio" value="radio1" formControlName="radiobtn" [(ngModel)]="readioSelected"
                (change)="showContent(readioSelected)" />
              <span> Bulk </span>
              <input type="radio" value="radio2" formControlName="radiobtn" [(ngModel)]="readioSelected"
                (change)="showContent(readioSelected)" />
              <span> Single </span>
            </div>
            <div *ngIf="submitted && f.radiobtn.errors" class="invalid-feedback">
              <div *ngIf="f.radiobtn.errors.required">
                Last Name is required
              </div>
            </div>
          </div>

          <div *ngIf="bulk_bool" class="form-group col-10">

            <div class="row">
              <div class="form-group col-6">
                <label>Number of Students </label>
                <input type="text" formControlName="numberofstud" class="form-control" [ngModel]="numberStud" [ngClass]="{
                  'is-invalid': submitted && f.numberofstud.errors
                }" maxlength="2" (keyup)="onKey($event)" maxlength="2" placeholder="Enter Number of Students" />
                <div *ngIf="submitted && f.numberofstud.errors" class="invalid-feedback">
                  <div *ngIf="f.numberofstud.errors.required">
                    Number of stud is required
                  </div>
                </div>
              </div>
              <div class="form-group col-6">
                <label>Total Amount</label>
                <input [attr.disabled]='true' type="text" formControlName="amount" [(ngModel)]="totAmount"
                  class="form-control" [ngClass]="{
                  'is-invalid': submitted && f.amount.errors
                }" placeholder="Total Amount" />
                <div *ngIf="submitted && f.amount.errors" class="invalid-feedback">
                  <div *ngIf="f.amount.required">
                    amount is required
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="single_bool" class="form-group col-10">
            <div class="form-group col-6">
              <label>Register Number</label>
              <select formControlName="singlerollno" class="form-control" [ngClass]="{
                  'is-invalid': submitted && f.singlerollno.errors
                }">
                <option *ngFor="let rollno of singlerollnoval" [value]="rollno">
                  {{ rollno }}
                </option>
              </select>
              <div *ngIf="submitted && f.singlerollno.errors" class="invalid-feedback">
                <div *ngIf="f.singlerollno.errors.required">
                  Roll Number code is required
                </div>
              </div>
            </div>
          </div>



          <div class="form-group col-12">
            <label>Addional Description</label>
            <textarea formControlName="descreption" class="form-control" [ngClass]="{
              'is-invalid': submitted && f.descreption.errors
            }" rows="3" style="resize: none;">

            </textarea>
            <!-- <input
              type="text"
              formControlName="descreption" class="form-control"
            [ngClass]="{
              'is-invalid': submitted && f.descreption.errors
            }"

            /> -->

            <div *ngIf="submitted && f.descreption.errors" class="invalid-feedback">
              <div *ngIf="f.descreption.errors.maxLength">
                Addional Description length 500
              </div>
            </div>
          </div>
          <div class="form-group form-check">
            <input type="checkbox" formControlName="acceptTerms" id="acceptTerms" class="form-check-input" [ngClass]="{
                'is-invalid': submitted && f.acceptTerms.errors
              }" />
            <label for="acceptTerms" class="form-check-label">I agree that all the above information are correct</label>
            <div *ngIf="submitted && f.acceptTerms.errors" class="invalid-feedback">
              I agree that all the above information are correct
            </div>
          </div>

          <div class="form-group col-12">
            <div class="text-center">
              <button class="btn btn-primary mr-1">Submit</button>
              <button class="btn btn-secondary" type="reset" (click)="onReset()">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>